import controller from './categories-accordion.controller'; 
import templateT1 from './templates/categories-accordion-t1.html';
import templateAD from './templates/categories-accordion-adaptative.html';

let CategoriesAccordionComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        items: '<',
        hCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  if(__env.adaptative){
    return templateAD;
  }else{
    let response = SessionService.get('components');   
    return templateT1;
  }

}

export default CategoriesAccordionComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/categories-filter/categories-accordion/categories-accordion.component.js
 **/